export default {
  set: (value) => localStorage.setItem('energybalance', value),
  get: () => JSON.parse(localStorage.getItem('energybalance')),
  clear: () => localStorage.removeItem('energybalance')
}
